// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"678":"f118c6a9","787":"eaf04a2c"}[chunkId] + ".chunk.js";
};